import { Component, inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType, PersistedModalName } from '@app/shared/models/modal.model';
import { RouteParameterInterceptor } from '@app/shared/services/routeParameterInterceptor.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import {
  WizardModalComponent,
  WizardModalData,
} from '@app/shared/components/modals/wizard-modal/wizard-modal.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { GamesRepository } from '@app/shared/state/games/games.repository';

@Component({
  selector: 'slotcom-campaign-modal',
  templateUrl: './campaign-modal.component.html',
  styleUrls: ['./campaign-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, WizardModalComponent, SharedModule, NavigationButtonComponent],
})
export class CampaignModalComponent implements OnInit {
  private readonly eventManager = inject(EventManager);
  private readonly routeParameterInterceptorService = inject(RouteParameterInterceptor);
  private readonly dialog = inject(MatDialog);
  private readonly gamesRepo = inject(GamesRepository);
  readonly campaignModalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  wizardModalData: WizardModalData;

  ngOnInit(): void {
    this.wizardModalData = new WizardModalData(
      this.campaignModalData.id,
      ModalType.Persisted,
      this.campaignModalData.properties.steps,
      this.campaignModalData.fullScreen,
      this.campaignModalData.properties.actionUrl
    );
  }

  closeModalByAction(actionUrl?: string) {
    if (actionUrl && this.gamesRepo.getAllGames().find((game) => game.gameId === actionUrl)) {
      this.eventManager.closeModal(
        new Modal(this.campaignModalData.id, ModalType.Persisted, this.campaignModalData, '', true)
      );

      this.dialog
        .getDialogById(this.campaignModalData.id)
        .afterClosed()
        .subscribe(() => {
          this.routeParameterInterceptorService.checkActionUrlOld(actionUrl);
        });
    } else if (actionUrl) {
      this.closeModal();

      this.dialog
        .getDialogById(this.campaignModalData.id)
        .afterClosed()
        .subscribe(() => {
          this.routeParameterInterceptorService.checkActionUrlOld(actionUrl);
        });
    } else {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.campaignModalData.id, ModalType.Persisted, this.campaignModalData));
  }
}
